export default "__VITE_ASSET__BAFgrmZb__"